export const ExpenseIconV2 = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />
      <g clipPath="url(#clip0_9118_38835)">
        <path
          d="M24.6274 12.1607L23.5806 11.9902L19.3933 11.3084C18.4683 11.1577 17.5963 11.7855 17.4457 12.7105L14.9909 27.7847L14.6841 29.6689"
          stroke="#15112D"
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.3551 13.688L31.531 12.6054L27.8827 10.4401C27.0768 9.96175 26.0357 10.2273 25.5573 11.0333L17.7623 24.167L14.5913 29.3638"
          stroke="#15112D"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1524 33.8347C11.5475 33.1189 11.6375 32.0482 12.3533 31.4433L35.6844 11.7282C36.4003 11.1233 37.471 11.2133 38.0759 11.9291L49.0287 24.8908C49.6336 25.6067 49.5437 26.6774 48.8278 27.2823L25.4967 46.9974C24.7808 47.6023 23.7102 47.5124 23.1052 46.7965L12.1524 33.8347Z"
          stroke="#15112D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.7816 31.9551C34.2133 30.7452 34.3932 28.6039 33.1834 27.1722C31.9735 25.7404 29.8322 25.5606 28.4005 26.7704C26.9687 27.9802 26.7889 30.1216 27.9987 31.5533C29.2085 32.985 31.3499 33.1649 32.7816 31.9551Z"
          stroke="#15112D"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.8334 38.0759C24.5365 37.4817 24.6248 36.4301 24.0307 35.727C23.4366 35.0239 22.3849 34.9355 21.6818 35.5297C20.9787 36.1238 20.8903 37.1755 21.4845 37.8786C22.0786 38.5817 23.1303 38.67 23.8334 38.0759Z"
          stroke="#15112D"
          strokeWidth="1.01818"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.8334 23.5305C40.5365 22.9363 40.6248 21.8847 40.0307 21.1816C39.4366 20.4785 38.3849 20.3901 37.6818 20.9843C36.9787 21.5784 36.8903 22.63 37.4845 23.3332C38.0786 24.0363 39.1303 24.1246 39.8334 23.5305Z"
          stroke="#15112D"
          strokeWidth="1.01818"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M38.7951 55.1816C45.8242 55.1816 51.5224 49.4834 51.5224 42.4543C51.5224 35.4252 45.8242 29.7271 38.7951 29.7271C31.7661 29.7271 26.0679 35.4252 26.0679 42.4543C26.0679 49.4834 31.7661 55.1816 38.7951 55.1816Z"
        fill="white"
        stroke="url(#paint0_linear_9118_38835)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M32.4312 42.4546H45.1584H32.4312Z" fill="white" />
      <path
        d="M32.4312 42.4546H45.1584"
        stroke="url(#paint1_linear_9118_38835)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9118_38835"
          x1="38.7951"
          y1="29.7271"
          x2="38.7951"
          y2="55.1816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9118_38835"
          x1="38.7948"
          y1="42.4546"
          x2="38.7948"
          y2="43.4546"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <clipPath id="clip0_9118_38835">
          <rect
            width="40.7273"
            height="40.7273"
            fill="white"
            transform="translate(10.2271 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
